import { useEffect } from 'react'

const LISTING_ALERT_POPUP_STORAGE_KEY = 'conrad-listing-alert-popup-shown'

const TIMEBEFORE_POPUP_OPEN_MS = 3000

/**
 * Wraps routes and auto-opens the ListingAlertPopup after a short delay.
 * A localStorage flag prevents the popup from showing again on refresh.
 */
export default function AutoPopupProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    if (typeof window === 'undefined') return
    if (window.localStorage.getItem(LISTING_ALERT_POPUP_STORAGE_KEY)) return

    const timer = window.setTimeout(() => {
      window.localStorage.setItem(LISTING_ALERT_POPUP_STORAGE_KEY, 'true')
    }, TIMEBEFORE_POPUP_OPEN_MS)

    return () => window.clearTimeout(timer)
  }, [])

  return children
}
